import { Component, Vue, Prop } from 'vue-property-decorator';
import { WelcomeProject } from '@/models';
import RightArrowIcon from '@/components/common/right-arrow-icon/RightArrowIcon.vue';
@Component({
  components: {
    RightArrowIcon
  }
})
export default class WelcomeProjectCard extends Vue {
  @Prop() private project: WelcomeProject;
}
